import { render, staticRenderFns } from "./FragmentRecurringTable.vue?vue&type=template&id=2e122260&scoped=true"
import script from "./FragmentRecurringTable.vue?vue&type=script&lang=ts"
export * from "./FragmentRecurringTable.vue?vue&type=script&lang=ts"
import style0 from "./FragmentRecurringTable.vue?vue&type=style&index=0&id=2e122260&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e122260",
  null
  
)

export default component.exports